module.exports = __webpack_public_path__ + "img/title1.7969f887.png";